import { render, staticRenderFns } from "./Inquiry-View.vue?vue&type=template&id=257c4345&scoped=true&"
import script from "./Inquiry-View.vue?vue&type=script&lang=js&"
export * from "./Inquiry-View.vue?vue&type=script&lang=js&"
import style0 from "./Inquiry-View.vue?vue&type=style&index=0&id=257c4345&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257c4345",
  null
  
)

export default component.exports